




















































































































































import { Vue, Component }    from 'vue-property-decorator'
import { mapGetters, mapState }               from 'vuex'
import { FontAwesomeIcon }          from '@fortawesome/vue-fontawesome'
import { convertDateLocalValeurT, convertDateUTCValeurT, dateIsBetween, dateNow, formatDateHoursMinutes, getDayMonthYear } from '@/utils/helpers'
import { code_publishable } from '@/types/Publishable'
import { code_publishable_message } from '@/types/PublishableMessage'
import { etat_validated_datas, etat_transfered_datas, opened_datas } from '@/types/Publication'
import { Ability } from '@/types/Ability'


@Component({
    computed: {
        etat_transfered_datas() {
            return etat_transfered_datas
        },
        ...mapGetters('auth', [
            'authUser',
            'can',
            'cannot',
            'isA',
            'isNotA'
        ]),
        ...mapState('publication', ['publications', 'loading_publications']),
        ...mapGetters('publication', ['get_publications_reclamations'])
    },
    components: {
        'font-awesome-icon': FontAwesomeIcon
    }
})

export default class AccesReclamations extends Vue
{
    Ability                        = Ability
    publications_reclamations: any = []
    publications_check: any        = []
    publication_select = {
        name: '',
        id: null,
        opened: 0,
        datas_transfered: null,
        datas_validated: null,
        start_at: '',
        end_at: '',
        publishable: null,
        message: '',
        all_publication_updated: 0
    }

    showModaleEditionAcces = false
    inverse_switch = false
    apply_all_publications = false
    error_dates: any = null

    /**
     * Retourne le libellé de l'état de validation des données
     */
    get_etat_validation (id: number, datas_transfered: number, datas_validated: number, publishable: any, libelle_check: any) {
        // libelle_check = JSON.parse(libelle_check)
        let retour: any = { libelle: '-', icon: '', color: 'secondary' }


        if (publishable && publishable.code === code_publishable.RECLAMATIONS_ECRITS) {
            // Notes finales ni transférées ni validées
            if (datas_validated === etat_validated_datas.DATAS_VALIDATED_NON) {
                retour = { libelle: libelle_check.datas_ko, icon: 'times', color: 'secondary' }
                this.publications_check[id].validation_acces = false
            }
            // Notes finales non transférées mais validées
            if ((datas_transfered === etat_transfered_datas.DATAS_TRANSFERED_NON || datas_transfered === etat_transfered_datas.DATAS_TRANSFERED_EN_COURS) && datas_validated === etat_validated_datas.DATAS_VALIDATED_OUI) {
                retour = { libelle: libelle_check.datas_ok, icon: 'repeat-alt', color: 'info' }
                this.publications_check[id].validation_acces = false
            }
            // Transfert en erreur
            if (datas_transfered === etat_transfered_datas.DATAS_TRANSEFERED_ERREUR && datas_validated === etat_validated_datas.DATAS_VALIDATED_OUI) {
                retour = { libelle: libelle_check.datas_erreur_transfert, icon: 'times', color: 'danger' }
                this.publications_check[id].validation_acces = false
            }
            // Notes finales validées
            if (datas_transfered === etat_transfered_datas.DATAS_TRANSEFERED_OUI && datas_validated === etat_validated_datas.DATAS_VALIDATED_OUI) {
                retour = { libelle: libelle_check.datas_ok, icon: 'check', color: 'success-bold' }
                this.publications_check[id].validation_acces = true
            }
        }
        if (publishable.code === code_publishable.RECLAMATIONS_ORAUX) {
            // Planification ni transférée ni validée
            if (datas_validated === etat_validated_datas.DATAS_VALIDATED_NON) {
                retour = { libelle: libelle_check.datas_ko, icon: 'times', color: 'secondary' }
                this.publications_check[id].validation_acces = false
            }
            // Planification non transférée mais validée
            if ((datas_transfered === etat_transfered_datas.DATAS_TRANSFERED_NON || datas_transfered === etat_transfered_datas.DATAS_TRANSFERED_EN_COURS) && datas_validated === etat_validated_datas.DATAS_VALIDATED_OUI) {
                retour = { libelle: libelle_check.datas_ok, icon: 'repeat-alt', color: 'info' }
                this.publications_check[id].validation_acces = false
            }
            // Transfert en erreur
            if (datas_transfered === etat_transfered_datas.DATAS_TRANSEFERED_ERREUR && datas_validated === etat_validated_datas.DATAS_VALIDATED_OUI) {
                retour = { libelle: libelle_check.datas_erreur_transfert, icon: 'times', color: 'danger' }
                this.publications_check[id].validation_acces = false
            }
            // Planification validée
            if (datas_transfered === etat_transfered_datas.DATAS_TRANSEFERED_OUI && datas_validated === etat_validated_datas.DATAS_VALIDATED_OUI) {
                retour = { libelle: libelle_check.datas_ok, icon: 'check', color: 'success-bold' }
                this.publications_check[id].validation_acces = true
            }
        }
        if (publishable.code === code_publishable.RECLAMATIONS_POSTCONCOURS) {
            // Résultats d\'admission ni transférés ni validés
            if (datas_validated === etat_validated_datas.DATAS_VALIDATED_NON) {
                retour = { libelle: libelle_check.datas_ko, icon: 'times', color: 'secondary' }
                this.publications_check[id].validation_acces = false
            }
            // Résultats d\'admission non transférés mais validés
            if ((datas_transfered === etat_transfered_datas.DATAS_TRANSFERED_NON || datas_transfered === etat_transfered_datas.DATAS_TRANSFERED_EN_COURS) && datas_validated === etat_validated_datas.DATAS_VALIDATED_OUI) {
                retour = { libelle: libelle_check.datas_ok, icon: 'repeat-alt', color: 'info' }
                this.publications_check[id].validation_acces = false
            }
            // Transfert en erreur
            if (datas_transfered === etat_transfered_datas.DATAS_TRANSEFERED_ERREUR && datas_validated === etat_validated_datas.DATAS_VALIDATED_OUI) {
                retour = { libelle: libelle_check.datas_erreur_transfert, icon: 'times', color: 'danger' }
                this.publications_check[id].validation_acces = false
            }
            // Résultats d\'admission validés
            if (datas_transfered === etat_transfered_datas.DATAS_TRANSEFERED_OUI && datas_validated === etat_validated_datas.DATAS_VALIDATED_OUI) {
                retour = { libelle: libelle_check.datas_ok, icon: 'check', color: 'success-bold' }
                this.publications_check[id].validation_acces = true
            }
        }
        return retour
    }

    /**
     * Retourne le libellé de la programmation des accés
     */
    get_programmation (id: number, start_at: Date, end_at: Date): { libelle: string; color: string } {
        const dateJour = dateNow()
        if (start_at === null && end_at === null) {
            this.publications_check[id].programmation_acces = false
            return { libelle: '-', color: 'secondary' }
        } else {
            const is_between = dateIsBetween(dateJour, start_at, end_at, [])
            if (is_between) {
                this.publications_check[id].programmation_acces = true
            } else {
                this.publications_check[id].programmation_acces = false
            }
            return { libelle: getDayMonthYear(start_at) + ' (' + formatDateHoursMinutes(start_at) + ') - ' + getDayMonthYear(end_at) +  ' (' + formatDateHoursMinutes(end_at) + ')', color: is_between ? 'success-bold' : 'secondary' }
        }
    }

    /**
     * Retourne l'état de blocage des accés
     */
    get_blocage (id: number, opened: number): { libelle: string; color: string; icon: string } {
        if (opened === opened_datas.OPENED_OUI) {
            this.publications_check[id].blocage_acces = true
            return { libelle: '', color: 'tertiary', icon: 'lock-open-alt' }
        } else if (opened === opened_datas.OPENED_NON) {
            this.publications_check[id].blocage_acces = false
            return { libelle: '', color: 'danger', icon: 'lock-alt' }
        }
        return { libelle: '-', color: 'secondary', icon: 'lock' }
    }

    /**
     * Retourne l'état selon les flags : validation des données, programmation des accés, blocage des accés
     */
    get_etat (id: number): { libelle: string; classe: string; icon: string; color: string } {
        if (this.publications_check[id].validation_acces && this.publications_check[id].programmation_acces && this.publications_check[id].blocage_acces) {
            return { libelle: 'PUBLIÉ', classe: 'bg_publier', icon: 'check', color: 'success-bold' }
        } else {
            return { libelle: 'NON PUBLIÉ', classe: 'bg_no_publier', icon: 'times', color: 'secondary' }
        }
    }

    // Retourne la classe pour le fond de la ligne
    get_classe (publication: any): string {
        const programmation_acces: any = this.get_programmation(publication.id, publication.start_at, publication.end_at)
        if (publication.datas_transfered === etat_transfered_datas.DATAS_TRANSEFERED_OUI && programmation_acces.color === 'success-bold' && publication.opened === opened_datas.OPENED_OUI) {
            return 'bg_publier'
        } else {
            return 'bg_no_publier'
        }
    }

    /**
     * Ouverture du popup d'édition des accès d'une publication
     */
    openEditionAcces (publication: any) {
        this.publication_select.id = publication.id
        this.publication_select.name = publication.name
        this.publication_select.opened = publication.opened
        this.publication_select.publishable = publication.publishable
        this.publication_select.datas_transfered = publication.datas_transfered
        this.publication_select.datas_validated =  publication.datas_validated

        if (publication.start_at && publication.end_at) {
            this.publication_select.start_at = convertDateLocalValeurT(publication.start_at)
            this.publication_select.end_at = convertDateLocalValeurT(publication.end_at)
        }
        this.inverse_switch = !this.publication_select.opened
        this.apply_all_publications = false

        // Récupère les messages concernant le publishable sélectionné
        let messages: any = []
        if (this.$store.state.publishableMessage.publishableMessages.length === 0) {
            const params = { publishable_id: publication.publishable.id }
            this.$store.dispatch('publishableMessage/getPublishableMessages', params).then(() => {
                messages = this.$store.getters['publishableMessage/publishableMessages_by_pid'](publication.publishable.id)
            })
        } else {
            messages = this.$store.getters['publishableMessage/publishableMessages_by_pid'](publication.publishable.id)
        }

        this.publication_select.message = messages.find((m: any) => m.code === code_publishable_message.PUBLICATION_BLOQUEE)
        this.showModaleEditionAcces = true
    }

    /**
     * Sauvegarde l'édition des accés d'une publication
     */
    saveEditionAcces () {
        this.error_dates = null
        this.$store.commit('publication/SET_LOADING', true)
        this.publication_select.opened = (this.inverse_switch ? 0 : 1)
        this.publication_select.all_publication_updated = this.apply_all_publications ? 1 : 0
        if (this.publication_select.start_at && this.publication_select.end_at) {
            this.publication_select.start_at = convertDateUTCValeurT(this.publication_select.start_at)
            this.publication_select.end_at = convertDateUTCValeurT(this.publication_select.end_at)
        }

        if ((this.publication_select.start_at && this.publication_select.end_at) || (!this.publication_select.start_at && !this.publication_select.end_at)) {
            this.$store.dispatch('publication/updatePublication', { publication_id: this.publication_select.id, payload: this.publication_select }).then(async () => {
                this.showModaleEditionAcces = false
                this.publication_select = {
                    name: '',
                    id: null,
                    opened: 0,
                    datas_transfered: null,
                    datas_validated: null,
                    start_at: '',
                    end_at: '',
                    publishable: null,
                    message: '',
                    all_publication_updated: 0
                }
                if (this.apply_all_publications) {
                    await this.$store.dispatch('publication/getPublications')
                }
                this.initDatas()
            })
        } else {
            // Formulaire de dates incorrect
            this.error_dates = 'Vous devez renseigner la date d\'ouverture et la date de fermeture.'
        }
    }

    /**
     * Ferme la popup d'édition des accés d'une publication
     */
    closeEditionAcces () {
        this.publication_select = {
            name: '',
            id: null,
            opened: 0,
            datas_transfered: null,
            datas_validated: null,
            start_at: '',
            end_at: '',
            publishable: null,
            message: '',
            all_publication_updated: 0
        }
        this.showModaleEditionAcces = false
    }

    /**
     * Relance la validation des données vers le portail
     */
    retryValidateDatas (publication_id: number) {
        this.$store.dispatch('publication/retryValidateDatas', publication_id).then(() => {
            this.initDatas()
        })
    }

    /**
     * Initialisation des données
     */
    initDatas () {
        this.publications_reclamations = this.$store.getters['publication/get_publications_reclamations']
        for (const p in this.publications_reclamations) {
            this.publications_check[this.publications_reclamations[p].id] = {
                validation_acces : false,
                programmation_acces: false,
                blocage_acces: false
            }
        }
    }

    mounted () {
        this.initDatas()
    }
}
